import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { type Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type { CustomerMetadata } from '../models/customer-metadata.model';
import type { CustomerLookupStrategy } from './customer-lookup.strategy';

/**
 * Strategy to look up customer metadata from the CDW Customer API.
 */
@Injectable()
export class CdwCustomerApiLookupStrategy implements CustomerLookupStrategy {
  // TODO: Replace with actual API endpoint from configuration
  private readonly apiUrl = '/api/customer-lookup'; // Placeholder

  constructor(private http: HttpClient) {}

  /**
   * Looks up customer metadata for the given domain via API.
   * @param domain The domain to look up.
   * @returns An observable emitting the customer metadata.
   */
  lookup(domain: string): Observable<CustomerMetadata> {
    if (!domain) {
      return throwError(() => new Error('Domain is required for API lookup.'));
    }

    const params = new HttpParams().set('domain', domain);

    // TODO: Add appropriate error handling, request headers, etc.
    return this.http.get<CustomerMetadata>(this.apiUrl, { params }).pipe(
      catchError((error) => {
        // TODO: Replace with proper logging service
        // Rethrow or handle error as appropriate for the application
        return throwError(() => new Error('Customer API lookup failed.'));
      })
    );
  }
}
